import { getCurrentLang } from './http'
import config from '../config'
import store from '../store'
import { number } from 'mathjs';
// 日期格式化
export const dateFormat = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  const dateTime = new Date(date);
  const o = {
    'M+': dateTime.getMonth() + 1, // month
    'D+': dateTime.getDate(), // day
    'H+': dateTime.getHours(), // hour
    'm+': dateTime.getMinutes(), // minute
    's+': dateTime.getSeconds(), // second
    'q+': Math.floor((dateTime.getMonth() + 3) / 3), // quarter
    S: dateTime.getMilliseconds() // millisecond
  };
  if (/(Y+)/.test(format)) {
    format = format.replace(RegExp.$1, `${dateTime.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  });
  return format;
};

/**
 * 数字千位符格式化
 * eg:
 * 17267737 -> 17,267,737
 */
export const numberFormat = (num) => {
  if (num && Number(num)) {
    const numStr = TtoFixed(num, 2)
    const numPre = numStr.slice(0, numStr.indexOf('.'))
    const numRi = numStr.slice(numStr.indexOf('.') + 1)
    const intStr = numPre.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    const floatStr = numRi ? `.${numRi.length < 2 ? numRi + '0' : numRi}` : '.00'
    return `${intStr}${floatStr}`
  } else {
    return '0.00'
  }
}
export const numberFormatA = (num) => {
  if (num && Number(num)) {
    const numStr = TtoFixed(num, 2)
    const numPre = numStr.slice(0, numStr.indexOf('.'))
    // const numRi = numStr.slice(numStr.indexOf('.') + 1)
    const intStr = numPre.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    // const floatStr = numRi ? `.${numRi.length < 2 ? numRi + '0' : numRi}` : ''
    return `${intStr}`
  } else {
    return '0'
  }
}
const TtoFixed = (num, decimal) => {
  num = num.toString();
  let index = num.indexOf('.');
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1)
  } else {
    num = num.substring(0)
  }
  return parseFloat(num).toFixed(decimal)
}

/*
 * 格式化电话号码
 * 参数说明：
 * num：要格式化的电话号码
 * */
export function phoneNumber(num) {
  if (num) {
    return num.substring(0, 3) + "*****" + num.substring(8, 11);
  }
  return "";
}

/**
 * 将字符串复制到剪贴板
 * @param {string} text
 */
export function copyTextToClipboard(text) {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(text);
  } else {
    const textarea = document.createElement("textarea");
    document.body.appendChild(textarea);
    textarea.style.position = "fixed";
    textarea.style.clip = "rect(0 0 0 0)";
    textarea.style.top = "10px";
    textarea.value = text;
    textarea.select();
    document.execCommand("copy", true);
    document.body.removeChild(textarea);
  }
}

export function downloadImage(url) {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.position = "fixed";
  a.style.clip = "rect(0 0 0 0)";
  a.style.top = "10px";
  a.href = url;
  a.download = url;
  a.click();
  document.body.removeChild(a);
}

// 将file文件上传转化为base64进行显示
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    ///FileReader类就是专门用来读文件的
    const reader = new FileReader();
    //开始读文件
    //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
    reader.readAsDataURL(file);
    // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
    reader.onload = () => resolve(reader.result);
    // 失败返回失败的信息
    reader.onerror = (error) => reject(error);
  });
}

export function emptyStr(str) {
  return !str || str.trim() === ""
}

export function openChatPage(token = "", partyId = "", name = "", productId = "") {
  // const token = localStorage.getItem(BIZ_TOKEN);
  const avatar = store.getters.userInfo.avatar;
  window.open(`${config.HOST_URL}/chat/#/pc/yellow?token=${token}&partyid=${partyId}&name=${name}&lang=${getCurrentLang().lang}&selfimg=${avatar}&productId=${productId}`, '_blank')

}


export function debounce(func, wait = 500) {
  let timeout;

  return function () {
    let context = this; // 保存this指向
    let args = arguments; // 拿到event对象

    clearTimeout(timeout)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, wait);
  }
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 按指定小数位格式化数字（含千分位）
 */
export const formatNumberScale = (num, decimals = 2) => {
  const n = Number(num) || 0
  const fixed = n.toFixed(decimals)
  const dotIndex = fixed.indexOf('.')
  const intStr = (dotIndex === -1 ? fixed : fixed.slice(0, dotIndex))
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  return dotIndex === -1 ? intStr : intStr + fixed.slice(dotIndex)
}

/**
 * 多币种价格格式化（Phase 2 · 用户端展示换算）
 * 入参 baseAmount 为基准币（USD）金额，按当前所选币种换算展示。
 * 选中非基准币 -> "当地价（基准币价）"；选中基准币或汇率未就绪 -> 仅基准币价。
 * options.estimate 为真时前缀"约"（用于结算预览估算）。
 */
export const formatCurrency = (baseAmount, options = {}) => {
  const amount = Number(baseAmount) || 0
  const list = store.getters.currencyList || []
  const base = store.getters.baseCurrency
  const cur = store.getters.currentCurrency
  const baseCur = list.find((c) => c.currencyCode === base)
  const baseSymbol = baseCur ? baseCur.currencySymbol : '$'
  const baseDp = baseCur && baseCur.decimalPlaces != null ? baseCur.decimalPlaces : 2
  const basePart = `${baseSymbol}${formatNumberScale(amount, baseDp)}`
  // #region agent log
  if (typeof window !== 'undefined') { window.__fcLog = (window.__fcLog || 0); if (window.__fcLog < 6) { window.__fcLog++; fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'run1',hypothesisId:'C',location:'util:formatCurrency',message:'format call',data:{listLen:list.length,base:base,baseSymbol:baseSymbol,cur:cur&&cur.currencyCode},timestamp:Date.now()})}).catch(()=>{}); } }
  // #endregion
  if (!cur || !cur.rate || cur.currencyCode === base) {
    return options.estimate ? `约 ${basePart}` : basePart
  }
  const dp = cur.decimalPlaces != null ? cur.decimalPlaces : 2
  const localPart = `${cur.currencySymbol}${formatNumberScale(amount * Number(cur.rate), dp)}`
  const result = `${localPart}（${basePart}）`
  return options.estimate ? `约 ${result}` : result
}

/**
 * 订单金额格式化（Phase 3 · 交易链路锁汇率）
 * 按订单自带的快照汇率换算，不随实时汇率变动。
 * order 需含 displayCurrencyCode / baseCurrencyCode / exchangeRate；
 * 旧订单无快照字段时按基准币展示。
 */
export const formatOrderPrice = (baseAmount, order) => {
  const amount = Number(baseAmount) || 0
  const list = store.getters.currencyList || []
  const o = order || {}
  const baseCode = o.baseCurrencyCode || store.getters.baseCurrency
  const baseCur = list.find((c) => c.currencyCode === baseCode)
  const baseSymbol = baseCur ? baseCur.currencySymbol : '$'
  const baseDp = baseCur && baseCur.decimalPlaces != null ? baseCur.decimalPlaces : 2
  const basePart = `${baseSymbol}${formatNumberScale(amount, baseDp)}`
  // 关闭多币种时：统一用当前基准币（人民币）符号展示，忽略订单历史快照基准币与展示币，
  // 避免老订单（基准币=USD）显示美元符号，也避免双币种叠加展示。
  const orderMultiCurrencyEnabled = (typeof localStorage !== 'undefined') && localStorage.getItem('shop_multiCurrencyEnabled') !== 'false'
  let disabledPart = basePart
  if (!orderMultiCurrencyEnabled) {
    const curBase = store.getters.baseCurrency
    const curBaseCur = list.find((c) => c.currencyCode === curBase)
    const curBaseSymbol = curBaseCur ? curBaseCur.currencySymbol : baseSymbol
    const curBaseDp = curBaseCur && curBaseCur.decimalPlaces != null ? curBaseCur.decimalPlaces : baseDp
    disabledPart = `${curBaseSymbol}${formatNumberScale(amount, curBaseDp)}`
  }
  // #region agent log
  if (typeof window !== 'undefined') { window.__fopLog = (window.__fopLog || 0); if (window.__fopLog < 6) { window.__fopLog++; fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix2',hypothesisId:'G',location:'util:formatOrderPrice',message:'order price format',data:{snapBase:baseCode,display:o.displayCurrencyCode,mcEnabled:orderMultiCurrencyEnabled,curBase:store.getters.baseCurrency,out:disabledPart},timestamp:Date.now()})}).catch(()=>{}); } }
  // #endregion
  if (!orderMultiCurrencyEnabled) {
    return disabledPart
  }
  const display = o.displayCurrencyCode
  const rate = Number(o.exchangeRate)
  if (!display || !rate || display === baseCode) {
    return basePart
  }
  const dispCur = list.find((c) => c.currencyCode === display)
  const symbol = dispCur ? dispCur.currencySymbol : display
  const dp = dispCur && dispCur.decimalPlaces != null ? dispCur.decimalPlaces : 2
  const localPart = `${symbol}${formatNumberScale(amount * rate, dp)}`
  return `${localPart}（${basePart}）`
}